module.exports = __webpack_public_path__ + "img/19.8f677d40.png";